import React, { memo, useCallback, useEffect } from 'react'

import { Icon, Add, RotatingSpinner, Check } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'
import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import { iconSizeNav } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setHasGenerated } from 'Pods/ThreeDStudio/Store/actions/generation'
import { clearModelSettings } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

function CollapsedModelStatusCard() {
  const t = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const isGenerating = useThreeDStudioStore(state => state.generation.isGenerating)
  const isEnhancing = useThreeDStudioStore(state => state.generation.isEnhancing)
  const hasGenerated = useThreeDStudioStore(state => state.generation.hasGenerated)

  useEffect(() => {
    if (!hasGenerated) return undefined

    const timeoutId = setTimeout(() => {
      setHasGenerated(false)
    }, 3000)

    return () => clearTimeout(timeoutId)
  }, [hasGenerated])

  const handleClick = useCallback(() => {
    clearModelSettings()
    if (location?.pathname !== '/ai') {
      navigate('/ai')
    }
  }, [navigate, location])

  if (hasGenerated) {
    return (
      <div className="collapsed-model-status-card collapsed-model-status-card--generated" onClick={handleClick}>
        <Icon svgComponent={Check} size={iconSizeNav} color="dark" notSpaced />
      </div>
    )
  }

  if (isEnhancing) {
    return (
      <DesktopOnlyTooltip
        content={t('sidebar.status.processing')}
        id="collapsed-model-status-card-processing-tooltip"
        place="right"
      >
        <div className="collapsed-model-status-card collapsed-model-status-card--processing" onClick={handleClick}>
          <Icon svgComponent={RotatingSpinner} size={iconSizeNav} color="dark" notSpaced />
        </div>
      </DesktopOnlyTooltip>
    )
  }

  if (isGenerating) {
    return (
      <DesktopOnlyTooltip
        content={t('sidebar.status.generating')}
        id="collapsed-model-status-card-generating-tooltip"
        place="right"
      >
        <div className="collapsed-model-status-card collapsed-model-status-card--generating" onClick={handleClick}>
          <Icon svgComponent={RotatingSpinner} size={iconSizeNav} color="dark" notSpaced />
        </div>
      </DesktopOnlyTooltip>
    )
  }

  return (
    <DesktopOnlyTooltip
      content={t('sidebar.actions.generateNewModel')}
      id="collapsed-model-status-card-tooltip"
      place="right"
    >
      <div className="collapsed-model-status-card collapsed-model-status-card--new" onClick={handleClick}>
        <Icon svgComponent={Add} size={iconSizeNav} color="dark" notSpaced />
      </div>
    </DesktopOnlyTooltip>
  )
}

export default memo(CollapsedModelStatusCard)
